<!-- 轮播图 -->
<template>
  <div>
    <el-carousel class="h-40" height="10rem" indicator-position="none">
      <el-carousel-item
        class="h-40"
        v-for="(item, index) in slideShowList"
        :key="index"
      >
        <img
          @click="handleNavigateToDetail(item.id,item.title,item)"
          :src="item.coverPic"
          class="cursor-pointer w-full h-40"
        />
      </el-carousel-item>
    </el-carousel>
  </div>
</template>
<script>
import { getCmsapiSildeshow } from "../api/carousel";
import { defaultSlideShowList } from "../config/header";
import { array_ } from "../utils";

export default {
  name: "mobile-carousel",
  data() {
    return {
      slideShowList: [], //轮播图的数组
    };
  },
  methods: {
    // 加载轮播图
    async getSlideShow() {
      // 调用轮播图数据Api
      const data = await getCmsapiSildeshow();
      // 数据获取验证过滤
      const list = array_(data);
      console.log(list,'listMb')
      // con
      // 数据处理
      // const formatList = list.map((item) => {
      //   return {
      //     ...item,
      //     coverPic: "/mainsys/UserFiles/coverpic/" + String(item?.picUrl),
      //   };
      // });

      // console.log(formatList,'formatList')
      // 空数据返回默认数组
      // this.slideShowList = list?.length
      //   ? list
      //   : defaultSlideShowList;
      this.slideShowList = defaultSlideShowList;
    },
    // 跳转详情页
    handleNavigateToDetail(contentId,title,item) {
      if(item.coverUrl){
        window.open(item.coverUrl)
      }
      // this.$router.push({
      //   name: "Detail",
      //   params: { contentId: contentId,label:title},
      // });
    },
  },

  created() {
    // 加载轮播图
    this.getSlideShow();
  },
};
</script>
<style>
>>> .el-carousel__item {
  background: url("~@/assets/lbbanner.jpg") no-repeat !important;
  background-size: 100% 100% !important;
}
</style>
